import { Button, Table, Tbody, Td, Th, Thead, Tr } from 'lynkco-up-core';
import { GetUpdateVersions, ManagementQuery, UpdateVersions } from '../../modules/UpdateManagement/types';
import { LoadingMask } from '../../components';
import { useEffect, useState } from 'react';
import { getVersions } from '../../modules/UpdateManagement/managementMethods';

type prop = {
  filteredModel: string;
  showOnlyActive: boolean;
  openDialog: (display: string, managementObject?: UpdateVersions) => void;
  setIsUpdating: React.Dispatch<React.SetStateAction<boolean>>;
  isUpdating: boolean;
};

function ManagementTable({ filteredModel, showOnlyActive, openDialog, setIsUpdating, isUpdating }: prop) {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<GetUpdateVersions | undefined>();
  const [query, setQuery] = useState<ManagementQuery | undefined>();

  const fillerArray = new Array(5).fill(0).map(() => Math.random());

  async function fetchData() {
    if (query) {
      try {
        setIsLoading(true);
        const responseData = await getVersions(query);
        setData(responseData);
      } catch (error) {
        console.error('Error occurred while fetching management updates: ', error);
      } finally {
        setIsLoading(false);
      }
    }
  }

  useEffect(() => {
    fetchData();
    setIsUpdating(false);
  }, [query]);

  useEffect(() => {
    setQuery(() => ({
      pageNumber: 1,
      pageSize: 200,
      onlyLatest: showOnlyActive,
      vehicleModels: filteredModel,
    }));
  }, [filteredModel, showOnlyActive, isUpdating]);

  return (
    <div className="overflow-x-scroll">
      <Table extraClasses="min-w-max">
        <Thead extraClasses="!bg-neutral-50">
          {!showOnlyActive ? (
            <Tr>
              <Th>
                <span className="font-medium text-sm text-neutral-400 flex justify-start">Application</span>
              </Th>
              <Th>
                <span className="font-medium text-sm text-neutral-400 flex justify-start">Package Name</span>
              </Th>
              <Th>
                <span className="font-medium text-sm text-neutral-400 flex justify-start">Version</span>
              </Th>
              <Th>
                <span className="font-medium text-sm text-neutral-400 flex justify-start">Release note</span>
              </Th>
              <Th>
                <span className="font-medium text-sm text-neutral-400 flex justify-start">Status</span>
              </Th>
              <Th cellWidth={100}>
                <span className="font-medium text-sm text-neutral-400 flex justify-start">Active</span>
              </Th>
              <Th>
                <span className="font-medium text-sm text-neutral-400 flex justify-start"></span>
              </Th>
            </Tr>
          ) : (
            <Tr>
              <Th>
                <span className="font-medium text-sm text-neutral-400 flex justify-start">Application</span>
              </Th>
              <Th>
                <span className="font-medium text-sm text-neutral-400 flex justify-start">Package Name</span>
              </Th>
              <Th>
                <span className="font-medium text-sm text-neutral-400 flex justify-start">Version</span>
              </Th>
              <Th>
                <span className="font-medium text-sm text-neutral-400 flex justify-start">Release note</span>
              </Th>
              <Th>
                <span className="font-medium text-sm text-neutral-400 flex justify-start">Status</span>
              </Th>
              <Th cellWidth={5}>
                <span className="font-medium text-sm text-neutral-400 flex justify-start"></span>
              </Th>
            </Tr>
          )}
        </Thead>
        <Tbody>
          {isLoading ? (
            fillerArray.map(_ => (
              <Tr key={_}>
                <Td>
                  <LoadingMask />
                </Td>
                <Td>
                  <LoadingMask />
                </Td>
                <Td>
                  <LoadingMask />
                </Td>
                <Td>
                  <LoadingMask />
                </Td>
                <Td>
                  <LoadingMask />
                </Td>
              </Tr>
            ))
          ) : data ? (
            data.content.map((entity, index) => {
              const rowColourIntensity = index % 2 ? '50' : '0';
              return !showOnlyActive ? (
                <Tr key={index} extraClasses={`bg-primary-${rowColourIntensity}`}>
                  <Td>
                    <div className="text-sm text-neutral-800">{entity.applicationName}</div>
                  </Td>
                  <Td>
                    <div className="text-sm text-neutral-800">{entity.packageName}</div>
                  </Td>
                  <Td>
                    <div className="text-sm text-neutral-800">{entity.version}</div>
                  </Td>
                  <Td>
                    <div className="text-sm text-neutral-800 max-w-[400px]">{entity.releaseNote}</div>
                  </Td>
                  <Td>
                    <div className="text-sm text-neutral-800">{entity.status}</div>
                  </Td>
                  <Td>
                    <div className="text-sm text-neutral-800">{entity.latest ? 'Active' : 'Old version'}</div>
                  </Td>
                  <Td>
                    <div className="text-sm text-neutral-800 flex gap-1">
                      <Button onClick={() => openDialog('updateVersion', entity)}>Change</Button>
                      <Button variant="danger" onClick={() => openDialog('deleteVersion', entity)}>
                        Delete
                      </Button>
                    </div>
                  </Td>
                </Tr>
              ) : (
                <Tr key={index} extraClasses={`bg-primary-${rowColourIntensity}`}>
                  <Td>
                    <div className="text-sm text-neutral-800">{entity.applicationName}</div>
                  </Td>
                  <Td>
                    <div className="text-sm text-neutral-800">{entity.packageName}</div>
                  </Td>
                  <Td>
                    <div className="text-sm text-neutral-800">{entity.version}</div>
                  </Td>
                  <Td>
                    <div className="text-sm text-neutral-800 max-w-[400px]">{entity.releaseNote}</div>
                  </Td>
                  <Td>
                    <div className="text-sm text-neutral-800">{entity.status}</div>
                  </Td>
                  <Td>
                    <div className="text-sm text-neutral-800 flex gap-1">
                      <Button onClick={() => openDialog('updateVersion', entity)}>Change</Button>
                      <Button variant="danger" onClick={() => openDialog('deleteVersion', entity)}>
                        Delete
                      </Button>
                    </div>
                  </Td>
                </Tr>
              );
            })
          ) : (
            <p>Loading the page</p>
          )}
        </Tbody>
      </Table>
    </div>
  );
}

export default ManagementTable;
